

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface PatientCurrentMedicationParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface PatientCurrentMedication {
    id?: any;
    regId:string;
    medicineId:string;
    activeMedication:string;
    startDate:any;
    endDate:any;
    reason:string;
    tenantId: any;
    branchId: any;
    
    parameters?: PatientCurrentMedicationParameter[];
    links?: any;
    //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;

}



export abstract class PatientCurrentMedicationData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<PatientCurrentMedication[]>;
    abstract create(url: string, data: PatientCurrentMedication): Observable<PatientCurrentMedication[]>;
    abstract update(url: string, data: PatientCurrentMedication): Observable<PatientCurrentMedication>;
    abstract delete(url: string): Observable<any>;
}
